import { render, staticRenderFns } from "./TheParsinaHeader.vue?vue&type=template&id=29744c09&scoped=true"
import script from "./TheParsinaHeader.vue?vue&type=script&lang=js"
export * from "./TheParsinaHeader.vue?vue&type=script&lang=js"
import style0 from "./TheParsinaHeader.vue?vue&type=style&index=0&id=29744c09&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29744c09",
  null
  
)

export default component.exports